import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import { setOrderNote } from '../Actions/Checkout.action';

const MiniCartProduct = ({
  includeVat,
  articleNumber,
  product,
  onCartItemIncrement,
  onCartItemDecrement,
  onCartItemRemove,
}) => {
  return (
    <div className="cart__product-row">
      <div className="cart__product-row--image">
        <div className="cart__product-row--image-wrapper">
          <img src={product.image} alt={product.imageAltText || product.name} />
        </div>
      </div>
      <div className="cart__product-row--info">
        <div className="cart__product-row--title-sku-trash-wrapper">
          <div className="cart__product-row--title-sku">
            <a href={product.url}>{product.name}</a>
            <span>{articleNumber}</span>
          </div>
          <button
            className="cart__product-row__remove-button"
            onClick={onCartItemRemove}
          >
            <i className="far fa-trash-alt"></i>
          </button>
        </div>
        <div className="cart__product-row--quant-price">
          <div className="cart__product-row--quantity">
            <button
              className="cart__product-row__quantity-action"
              onClick={onCartItemDecrement}
              aria-label={translate('minicart.decrement')}
            >
              -
            </button>
            <div className="cart__product-row--quantity-display">
              <span>{product.quantity}</span>
            </div>
            <button
              className="cart__product-row__quantity-action cart__product-row__quantity-action--plus"
              onClick={onCartItemIncrement}
              aria-label={translate('minicart.increment')}
            >
              +
            </button>
          </div>
          <div className="cart__product-row--price">
            {product.campaignPrice ? (
              <Fragment>
                <span className="cart__product-row--camp-price">
                  {product.campaignPrice}
                  <span className="old-price">{product.price}</span>
                </span>
              </Fragment>
            ) : (
              product.price
            )}
            <span>
              {includeVat
                ? translate('minicart.inclvat')
                : translate('minicart.exclvat')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCartProduct;
